<div class="chat-container">
  <div class="nb-card-header" [ngClass]="{ 'no-messages': messages.length === 0 && !state.loading }">
      <div>{{name}}</div>
      <p>{{ assistantDescription}}</p>
  </div>
  <!-- <ng-container [ngSwitch]="path">

  </ng-container> -->
  <ng-container *ngIf="messages.length >0">
    <div class="message-flow">
      <div *ngFor="let message of messages" class="message" [ngClass]="message.type">
        <div class="message-content">
  
          <ng-container [ngSwitch]="message.type">
            <!-- Category Recommendations -->
            <div *ngSwitchCase="'category'" class="category-message">
              <h4>Suggested Categories:</h4>
              <div *ngFor="let category of message.content" class="category-item">
                <button nbButton (click)="selectCategory(category)">
                  {{ category.fullPath }}
                </button>
                <span class="confidence">({{ category.confidence }}%)</span>
              </div>
            </div>
  
            <!-- Feature Recommendations -->
            <div *ngSwitchCase="'feature'" class="feature-message">
              <h4>Recommended Features:</h4>
              <ul>
                <li *ngFor="let feature of message.content">
                  <strong>{{ feature.name }}</strong> - {{ feature.description }}
                  <span class="feature-type">{{ feature.type }}</span>
                </li>
              </ul>
            </div>
  
            <!-- Generated Descriptions -->
            <div *ngSwitchCase="'description'" class="description-message">
              <h4>{{ message.subType === 'short' ? 'Short Description' : 'Detailed Description' }}</h4>
              <p>{{ message.content }}</p>
              <div class="metadata" *ngIf="message.metadata">
                <span>Words: {{ message.metadata.wordCount }}</span>
                <span>Keywords: {{ message.metadata.keywords?.join(', ') }}</span>
              </div>
            </div>
  
            <!-- Error Messages -->
            <div *ngSwitchCase="'error'" class="error-message">
              <p>{{ message.content }}</p>
              <button class="retry-btn" (click)="retry()">Try Again</button>
            </div>
          </ng-container>
        </div>
      </div>
  
      <div *ngIf="state.loading" class="loading-indicator">
        <div class="spinner"></div>
        <span>Generating recommendations...</span>
      </div>
    </div>
  </ng-container>
  

  <div class="input-section">
    <ubs-input-panel
      [currentStep]="state.currentStep"
      [isLoading]="state.loading"
      (textSubmit)="handleTextInput($event)"
      (imageSubmit)="handleImageUpload($event)"
      (categoryDescriptionSubmit)="handleTextInput($event)">
    </ubs-input-panel>
  </div>
</div>